import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IUserContext, IHRLocation } from '@api'

interface ILoadPayload {
  context: IUserContext
  id: string
  isSuperUser: boolean
  company: {
    uuid: string
    name: string
    settings: {
      employeeImportNotificationEnabled: boolean
      hotelingDeskDeptEnforcementEnabled: boolean
    }
  }
  employee: {
    preferredLocations: IHRLocation[]
  }
}
export default function load(): Promise<ILoadPayload> {
  return client.gql.query({ query }).then(({ data: { viewer } }: any) => {
    const res = {
      ...viewer,
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      context: { ...defaultUserContext, ...JSON.parse(viewer.context) },
    }

    return res
  })
}

const query = gql`
  query {
    viewer {
      context
      id
      isSuperUser
      employee {
        id
        name
        assets {
          id
          url
        }
        preferredLocations {
          id
          location
        }
      }
      company {
        uuid
        name
        settings {
          employeeImportNotificationEnabled
          hotelingDeskDeptEnforcementEnabled
        }
      }
    }
  }
`
